var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.withWrapper)?_c('v-container',{attrs:{"pa-5":"","pa-sm-10":"","pa-lg-5":""}},[_vm._t("default")],2):_c('div',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }